import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import AddInlineCommentThread from './AddInlineCommentThread';
import addCommentIcon from '@ckeditor/ckeditor5-comments/theme/icons/add-comment.svg';

export class InlineCommentPlugin extends Plugin {
  static get pluginName() {
    return 'InlineCommentPlugin';
  }
  init() {
    this.editor.commands.add(
      'addInlineCommentThread',
      new AddInlineCommentThread(this.editor)
    );

    this.editor.ui.componentFactory.add('inlineComment', (locale) => {
      const view = new ButtonView(locale);

      view.set({
        label: 'Comment',
        tooltip: true,
        withText: false,
        icon: addCommentIcon,
      });

      view.on('execute', () => {
        /**
         * When comments only is enabled do this workaround to get the addInlineCommentThread command to execute
         * - Temporarily disable it so the addInlineCommentThread command can execute
         * - Enable again after executing the addInlineCommentThread command
         */
        const commentsOnly = this.editor.plugins.get('CommentsOnly').isEnabled;

        if (commentsOnly) {
          this.editor.plugins.get('CommentsOnly').isEnabled = false;
        }

        this.editor.execute('addInlineCommentThread');

        if (commentsOnly) {
          this.editor.plugins.get('CommentsOnly').isEnabled = true;
        }
      });

      return view;
    });
  }
}
